<template>
  <v-responsive height="265">
    <div :id="id" class="map_container"></div>
  </v-responsive>
</template>

<script>
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  props: {
    id: {
      type: String,
      default: 'map_id'
    },
    lat: {
      type: String,
      default: '0'
    },
    lng: {
      type: String,
      default: '0'
    },
    zoom: {
      type: Number,
      default: 7
    }
  },
  mounted () {
    let mymap = new L.Map(this.id, {doubleClickZoom: false})
    .setView(new L.LatLng(this.lat, this.lng), this.zoom);
    L.tileLayer(process.env.MAP_URL, {
      attribution: '© <a href="http://osm.org/copyright">OpenStreetMap</a>',
      minZoom: 12,
      maxZoom: 19
    }).addTo(mymap);
    L.marker([this.lat, this.lng])
    .bindTooltip('Ubicación', {permanent: true, direction: 'top', offset: L.point({x: 0, y: -12})})
    .addTo(mymap);
  }
};
</script>

<style>
@import "../../../node_modules/leaflet/dist/leaflet.css";

.map_container {
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  max-height: 260px;
  background-color: #ccc;
  z-index: 0;
}
.leaflet-container {
  border: 1px solid #ccc;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/common/util/ViewMap.vue